import useSWR from 'swr';
import { fetchGet, PATHNAME, schema } from '../api/booked-tickets';
import { withManageConfig } from './utils';

export const useBookedTickets = (params) => {
  const prms = withManageConfig(params);
  const key = schema.safeParse(prms).success ? { PATHNAME, ...prms } : null;
  return useSWR(key, fetchGet(prms), {
    revalidateOnFocus: false,
    revalidateIfStale: false
  });
};
